<template>
    <div class="addBox relative">
      <div class="title">
        <div class="title_left">
          <span class="movePoin" @click="$router.go(-1)">商品填报</span>
          /
          <span class="type">{{$route.query.type=='add'?'新增':'编辑'}}</span>
        </div>
      </div>
      <el-form :model="fillFormDto" :rules="rules" ref="fillFormDto" label-width="150px">
        <ToggleForm title="基本信息">
          <div class="content">
            <div class="row mt20">
              <el-form-item label="供应商名称：" prop="supplyId">
                <el-select v-model="fillFormDto.supplyId" placeholder="请选择供应商名称" clearable class="w300">
                  <el-option v-for="item in supplyLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="来源名称：">
                <el-select v-model="fillFormDto.sourceEntityId" placeholder="请选择来源名称" clearable class="w300">
                  <el-option v-for="item in entityLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="采购人：" prop="buyPerson">
                <el-input placeholder="请输入采购人" class="w300" maxlength="30" v-model="fillFormDto.buyPerson"></el-input>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="采购日期：" prop="buyDate">
                <el-date-picker v-model="fillFormDto.buyDate" value-format="yyyy-MM-dd" class="w300" :disabled="fillFormDto.prePackagedGoodsFillList.length>1 || fillFormDto.disPrePackagedGoodsFillList.length>1 || $route.query.type=='edit' || (fillFormDto.prePackagedGoodsFillList[0].effectiveDate!=''&&fillFormDto.prePackagedGoodsFillList[0].effectiveDate!=null)"
                  type="date" placeholder="请选择采购日期" :picker-options="buyDateZ" :clearable='false'></el-date-picker>
              </el-form-item>
            </div>
          </div>
        </ToggleForm>
        <ToggleForm title="商品信息">
          <div class="content">
            <el-tabs v-model="activeName" class="goodsFillAdd_table">
              <el-tab-pane name="ybz">
                <span slot="label" class="tabLab">预包装食品填报</span>
                <el-table :data="fillFormDto.prePackagedGoodsFillList" style="width: 100%;margin-top: 5px;">
                  <el-table-column prop="" min-width="20" label=""></el-table-column><!-- 占位 -->
                  <el-table-column min-width="120" label="商品名称">
                    <template slot-scope="scope">
                      <div class="margin-10">
                        <el-select v-model="scope.row.goodCode" placeholder="商品名称" v-if="scope.row.edit != 'ok'" 
                                   :id="scope.row.goodCode" clearable filterable @change="goodsChange(scope.row,goodsListsAll)">
                          <el-option v-for="item in goodsListsAll" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <span v-else>{{scope.row.goodName}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="155" label="采购量" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="margin-10">
                        <el-input placeholder="采购量" class="w100" maxlength="7" v-model="scope.row.buyQuantity" 
                                  v-if="scope.row.edit != 'ok'" @input="numZz(scope.row,'buyQuantity')"></el-input>
                        <span v-else>{{scope.row.buyQuantity}}</span>
                        {{scope.row.buyQuantityUnit}}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="155" label="商品单价" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="margin-10">
                        <el-input placeholder="商品单价" class="w80" maxlength="6" v-model="scope.row.price"
                                  v-if="scope.row.edit != 'ok'" @input="numZz(scope.row,'price')"></el-input>
                        <span v-else>{{scope.row.price}}</span>
                        {{scope.row.priceUnit}}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="150" label="生产日期" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="margin-10">
                        <el-date-picker v-model="scope.row.productionDate" value-format="yyyy-MM-dd" class="w140" type="date" placeholder="请选择日期"
                          :picker-options="productionDateZ" clearable v-if="scope.row.edit != 'ok'"></el-date-picker>
                        <span v-else>{{scope.row.productionDate}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="150" label="有效期至" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="margin-10">
                        <el-date-picker v-model="scope.row.effectiveDate" value-format="yyyy-MM-dd" class="w140" type="date" 
                          placeholder="请选择日期" :picker-options="effectiveDateZ" clearable v-if="scope.row.edit != 'ok'"></el-date-picker>
                        <span v-else>{{scope.row.effectiveDate}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="170" label="生产厂商" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="margin-10">
                        <el-input placeholder="请输入生产厂商" class="w160" maxlength="50" v-model="scope.row.productVendor" v-if="scope.row.edit != 'ok'"></el-input>
                        <span v-else>{{scope.row.productVendor}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="170" label="厂商地址" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="margin-10">
                        <el-input placeholder="请输入厂商地址" class="w160" maxlength="50" v-model="scope.row.productVendorAddr" v-if="scope.row.edit != 'ok'"></el-input>
                        <span v-else>{{scope.row.productVendorAddr}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="150" label="生产批次号" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="margin-10">
                        <el-input placeholder="请输入生产批次号" class="w140" maxlength="30" v-model="scope.row.productBatchNo" v-if="scope.row.edit != 'ok'"></el-input>
                        <span v-else>{{scope.row.productBatchNo}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="100" label="凭证" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span class="pinzheng_span" v-if="scope.row.edit == 'add'" @click="pzFun(scope.row,'add','pre')">上传凭证</span>
                      <span class="pinzheng_span" v-if="scope.row.edit != 'add'" @click="pzFun(scope.row)">编辑查看</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" min-width="140">
                    <template slot-scope="scope">
                      <a href="javascript:;" class="operate-a" @click="edit(scope.row)" v-if="scope.row.edit == 'ok'">编辑</a>
                      <a href="javascript:;" class="operate-a" @click="affirm(scope.row, 'pre')" v-if="scope.row.edit == 'add' || scope.row.edit == 'edit'">确认</a>
                      <a href="javascript:;" class="operate-a" @click="delConfirm(fillFormDto.prePackagedGoodsFillList,scope.row,fillFormDto.delPrePackagedGoodsFillList)" v-if="scope.row.edit != 'add'">删除</a>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane name="fybz">
                <span slot="label" class="tabLab">非预包装食品填报</span>
                <el-table class="tabLabDis" :data="fillFormDto.disPrePackagedGoodsFillList" style="width: 100%;margin-top: 5px;">
                  <el-table-column prop="" min-width="20" label=""></el-table-column><!-- 占位 -->
                  <el-table-column min-width="210" label="商品名称">
                    <template slot-scope="scope">
                      <div class="margin-10">
                        <el-select v-model="scope.row.goodCode" placeholder="商品名称" v-if="scope.row.edit != 'ok'"
                          :id="scope.row.goodCode" clearable filterable @change="goodsChange(scope.row,goodsListsAllT)" class="w200">
                          <el-option v-for="item in goodsListsAllT" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <span v-else>{{scope.row.goodName}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="175" label="采购量" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="margin-10">
                        <el-input placeholder="采购量" class="w120" maxlength="7" v-model="scope.row.buyQuantity"
                          v-if="scope.row.edit != 'ok'" @input="numZz(scope.row,'buyQuantity')"></el-input>
                        <span v-else>{{scope.row.buyQuantity}}</span>
                        {{scope.row.buyQuantityUnit}}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="195" label="商品单价" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="margin-10">
                        <el-input placeholder="商品单价" class="w120" maxlength="6" v-model="scope.row.price"
                                  v-if="scope.row.edit != 'ok'" @input="numZz(scope.row,'price')"></el-input>
                        <span v-else>{{scope.row.price}}</span>
                        {{scope.row.priceUnit}}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="100" label="凭证" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span class="pinzheng_span" v-if="scope.row.edit == 'add'" @click="pzFun(scope.row,'add','dis')">上传凭证</span>
                      <span class="pinzheng_span" v-if="scope.row.edit != 'add'" @click="pzFun(scope.row)">编辑查看</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" min-width="140">
                    <template slot-scope="scope">
                      <a href="javascript:;" class="operate-a" @click="edit(scope.row)" v-if="scope.row.edit == 'ok'">编辑</a>
                      <a href="javascript:;" class="operate-a" @click="affirm(scope.row, 'dis')"
                        v-if="scope.row.edit == 'add' || scope.row.edit == 'edit'">确认</a>
                      <a href="javascript:;" class="operate-a" @click="delConfirm(fillFormDto.disPrePackagedGoodsFillList,scope.row,fillFormDto.delDisPrePackagedGoodsFillList,)" v-if="scope.row.edit != 'add'">删除</a>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </ToggleForm>
      </el-form>
      <div class="foot-btn">
        <div>
          <el-button class="w70 mr10" @click="goBack">返回</el-button>
          <el-button calss="w70" :disabled="btn"  @click="submit('tj')">提交</el-button>
          <el-button type="primary w100" :disabled="btn"  @click="submit('tjjx')">提交并继续</el-button>
        </div>
      </div>
      <div class="pzPupopBox" v-if="pzUpShow">
        <div class="pzContentBox" :class="{'h374':!psytz}">
          <h3>凭证管理<i class="close el-icon-close" @click="qxPzUl"></i></h3>
          <span class="pzSpan">上传凭证：</span>
          <div class="pzUploadBox">
            <div class="pzUploadDiv">
              <ybUploadFill class="ybUpload" @changeFun="getFilesO" :baseUrl="baseUrl" :filesArr="tranVoucherList"></ybUploadFill>
              <ybUploadFill class="ybUpload" @changeFun="getFilesO" :baseUrl="baseUrl" :filesArr="animalVoucherList"></ybUploadFill>
              <ybUploadFill class="ybUpload" @changeFun="getFilesO" :baseUrl="baseUrl" :filesArr="otherVoucherList"></ybUploadFill>
            </div>
            <p class="imgNameP">
              <span>交易凭证</span>
              <span>动检证</span>
              <span>其他凭证</span>
            </p>
            <p class="tipP">图片大小不超过5M；</p>
            <p class="tipP">上传格式：jpg、png、gif；每一类最多上传1张图片。</p>
          </div>
          <p v-if="psytz" class="psytz">是否使用上一条凭证：<el-checkbox @change="checkedValueChange" v-model="checkedValue"></el-checkbox></p>
          <div class="btnDiv" :class="{'mt265':!psytz}">
            <el-button class="w70 mr10" @click="qxPzUl">取消</el-button>
            <el-button type="primary" class="w70" @click="tjPzUp">提交</el-button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import ToggleForm from "components/ToggleForm";
import ybUploadFill from "components/ybUploadFill";
import * as api from "api/report";
export default {
  name: "personAdd",
  components: { 
      ToggleForm,
      ybUploadFill,
  },
  data() {
    return {
      checkedValue: '',
      psytz: false,
      plhc: [],
      id: '',
      type: '',
      value: '',
      activeName: 'ybz',
      tableData: [],
      options: [],
      supplyLists: [],
      entityLists: [],
      goodsListsAll: [],
      goodsListsAllT: [],
      buyDateZ: {
        disabledDate: time => {
          return  time.getTime() < new Date('2017-12-31') || new Date() < time.getTime()
        }
      },
      productionDateZ: {
        disabledDate: time => {
          return time.getTime() < new Date('2009-12-31') || new Date() < time.getTime()
        }
      },
      productionDateZ: {
        disabledDate: time => {
          return time.getTime() < new Date('2009-12-31') || new Date() < time.getTime()
        }
      },
      effectiveDateZ: {
        disabledDate: time => {
          return (new Date() * 1 + 157680000000)  < time.getTime() || new Date(this.fillFormDto.buyDate) > time.getTime()+8.64e7
        }
      },
      fillFormDto: {
        supplyId: '',
        sourceEntityId: '',
        buyPerson: '',
        buyDate: '',
        delDisPrePackagedGoodsFillList: [], //删除的非预包装食品
        delPrePackagedGoodsFillList: [], //删除的预包装食品
        disPrePackagedGoodsFillList: [], //编辑或未编辑的非预包装食品
        prePackagedGoodsFillList: [], //编辑或未编辑的预包装食品
        id: ''
      },
      tranVoucherList: [],
      animalVoucherList: [],
      otherVoucherList: [],
      pzUpShow: false,
      qzZcObj: {},
      baseUrl: this.$store.state.common.baseUrl,
      btn: false,
      rules: {
        supplyId: [
          {
            required: true,
            message: '请选择供应商名称',
            trigger: 'blur'
          }
        ],
        buyPerson: [
          {
            required: true,
            message: '请输入采购人',
            trigger: 'blur'
          }
        ],
        buyDate: [
          {
            required: true,
            message: '请选择采购日期',
            trigger: 'blur'
          }
        ]
      },
    };
  },
  methods: {
    checkedValueChange(value){
      if(value){
        this.tranVoucherList = this.plhc.tranVoucherList ? this.plhc.tranVoucherList : [];
        this.animalVoucherList = this.plhc.animalVoucherList ? this.plhc.animalVoucherList : [];
        this.otherVoucherList = this.plhc.otherVoucherList ? this.plhc.otherVoucherList : [];
        if (this.tranVoucherList.length > 0 && this.tranVoucherList[0].fileUrl.slice(0, 4) != 'http') {
          this.tranVoucherList[0].url = this.baseUrl + '/' + this.tranVoucherList[0].fileUrl;
        }
        if (this.animalVoucherList.length > 0 && this.animalVoucherList[0].fileUrl.slice(0, 4) != 'http') {
          this.animalVoucherList[0].url = this.baseUrl + '/' + this.animalVoucherList[0].fileUrl;
        }
        if (this.otherVoucherList.length > 0 && this.otherVoucherList[0].fileUrl.slice(0, 4) != 'http') {
          this.otherVoucherList[0].url = this.baseUrl + '/' + this.otherVoucherList[0].fileUrl;
        }
      } else {
        this.tranVoucherList = [];
        this.animalVoucherList = [];
        this.otherVoucherList = [];
      }
    },
    goBack(){
       this.$confirm('返回列表后当前数据将不会被保存，是否确认返回？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        this.$router.go(-1)
      })
    },
    numZz(obj,key){
      obj[key] = obj[key].replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
      obj[key] = obj[key].replace(/^\./g, ""); //验证第一个字符是数字
      obj[key] = obj[key].replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
      obj[key] = obj[key].replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      obj[key] = obj[key].replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
    },
    allList(){
      api.supplyList().then(r=>{//供应商列表
        if(r.code == 200){
          this.supplyLists = r.data;
        }
      })
      api.entityList({size: 9999}).then(r => {//来源管理列表
        if (r.code == 200) {
          this.entityLists = r.data.records;
        }
      })
      api.goodsListAll({ prepackaged: 'YES', size: 9999}).then(r=>{
        if(r.code == 200){
          this.goodsListsAll = r.data.records
        }
      })
      api.goodsListAll({ prepackaged: 'NO', size: 9999}).then(r=>{
        if(r.code == 200){
          this.goodsListsAllT = r.data.records
        }
      })
    },
    initData() { //添加页初始化
      this.fillFormDto = {
        supplyId: '',
        sourceEntityId: '',
        buyPerson: '',
        buyDate: '',
        delDisPrePackagedGoodsFillList: [], //删除的非预包装食品
        delPrePackagedGoodsFillList: [], //删除的预包装食品
        disPrePackagedGoodsFillList: [], //编辑或未编辑的非预包装食品
        prePackagedGoodsFillList: [], //编辑或未编辑的预包装食品
        id: ''
      };
      this.addPrePackagedGoodsFillList();//添加预包装添加列表
      this.addDisPrePackagedGoodsFillList();//添加非预包装添加列表
    },
    addPrePackagedGoodsFillList(){//增加一条预包装添加项
      this.fillFormDto.prePackagedGoodsFillList.unshift({
        buyQuantity: '',   //采购量
        buyQuantityUnit: '',  //采购量单位
        effectiveDate: '',  //有效期
        fillType: 'YES', //预包装填报-> YES 非预包装填报 -> NO
        goodCode: '', //商品code
        goodName: '', //商品名称
        id: '', //商品填报(预包装和非预包装)列表id
        price: '',  //商品价格
        priceUnit: '',  //商品价格单位
        productBatchNo: '', //生产批次号
        productVendor: '',  //生产厂商
        productVendorAddr: '',  //厂商地址
        productionDate: '', //生产日期
        animalVoucher: '',//动检证
        tranVoucher: '',//交易凭证
        otherVoucher: '',//其他凭证
        edit: 'add',   //编辑状态
        voucherUrl: {}
      })
    },
    addDisPrePackagedGoodsFillList() {//增加一条非预包装添加项
      this.fillFormDto.disPrePackagedGoodsFillList.unshift({
        buyQuantity: '',   //采购量
        buyQuantityUnit: '',  //采购量单位
        fillType: 'NO', //预包装填报-> YES 非预包装填报 -> NO
        goodCode: '', //商品code
        goodName: '', //商品名称
        id: '', //商品填报(预包装和非预包装)列表id
        price: '',  //商品价格
        priceUnit: '',  //商品价格单位
        animalVoucher: '',//动检证
        tranVoucher: '',//交易凭证
        otherVoucher: '',//其他凭证
        edit: 'add',   //编辑状态
        voucherUrl: {}
      })
    },
    affirm(row, type){  //确认
      if(type == 'pre'){//预包装
        if (!(row.goodCode && row.buyQuantity && row.productionDate && row.effectiveDate && row.productVendor && row.productVendorAddr && row.productBatchNo)) {
          this.$message.warning('请填写当前行所有必填数据');
          return
        }
      } else if(type == 'dis'){//非预包装
        if (!(row.goodCode && row.buyQuantity)) {
          this.$message.warning('请填写当前行所有必填数据');
          return
        }
      }
      if(row.price>=1000){
        this.$message.warning('商品单价限制0-999.99');
        return
      }
      if (row.buyQuantity >= 10000 || row.buyQuantity <= 0){
        this.$message.warning('采购量限制0.01-9999.99');
        return
      }
      if (row.buyQuantity.slice(0,1) == 0 && row.buyQuantity.indexOf('.')<0) {
        this.$message.warning('采购量填写异常');
        return
      }
      if (row.price != '' &&row.price.slice(0,1) == 0 && row.price.indexOf('.')<0&& row.price!=0) {
        this.$message.warning('商品单价填写异常');
        return
      }
      if(row.edit == 'add' && type == 'pre'){
        this.addPrePackagedGoodsFillList();
      } else if(row.edit == 'add' && type == 'dis'){
        this.addDisPrePackagedGoodsFillList();
      }
      row.goodName = document.getElementById(row.goodCode).value;
      row.edit = 'ok';
    },
    edit(row){  //编辑
      row.edit = 'edit';
    },
    delConfirm(tablists, row, delList){//删除
      if((this.fillFormDto.prePackagedGoodsFillList.length + this.fillFormDto.disPrePackagedGoodsFillList.length)<=3){
        this.$message.warning('仅剩一条数据，无法删除。');
        return
      }
      tablists.splice(tablists.indexOf(row),1);
      if(row.isGet=='YES'){
        delList.push(row);
      }
    },
    getFilesO(files, state) {},
    pzFun(item,add,type){//上传编辑凭证
      this.pzUpShow = true;
      this.tranVoucherList = item.voucherUrl&&item.voucherUrl.tranVoucherList ? item.voucherUrl.tranVoucherList : [];
      this.animalVoucherList = item.voucherUrl&&item.voucherUrl.animalVoucherList ? item.voucherUrl.animalVoucherList : [];
      this.otherVoucherList = item.voucherUrl&&item.voucherUrl.otherVoucherList ? item.voucherUrl.otherVoucherList : [];

      if(this.tranVoucherList.length>0 && this.tranVoucherList[0].fileUrl.slice(0,4)!='http'){
        this.tranVoucherList[0].url = this.baseUrl + '/' + this.tranVoucherList[0].fileUrl;
      }
      if(this.animalVoucherList.length>0 && this.animalVoucherList[0].fileUrl.slice(0,4)!='http'){
        this.animalVoucherList[0].url = this.baseUrl + '/' + this.animalVoucherList[0].fileUrl;
      }
      if(this.otherVoucherList.length>0 && this.otherVoucherList[0].fileUrl.slice(0,4)!='http'){
        this.otherVoucherList[0].url = this.baseUrl + '/' + this.otherVoucherList[0].fileUrl;
      }
      this.qzZcObj = item;
      if(add == 'add'){
        if(type == 'dis'){//非预包装
          if(this.fillFormDto.disPrePackagedGoodsFillList.length>1){//上一条有记录
            if(this.fillFormDto.disPrePackagedGoodsFillList[1].voucherUrl.animalVoucherList 
               || this.fillFormDto.disPrePackagedGoodsFillList[1].voucherUrl.otherVoucherList
               || this.fillFormDto.disPrePackagedGoodsFillList[1].voucherUrl.tranVoucherList )
            {//有凭证图片
              this.plhc = this.fillFormDto.disPrePackagedGoodsFillList[1].voucherUrl;
              this.psytz = true;//可以使用上一条凭证按钮
            } else {
              this.psytz = false;
            }
          } else {
            this.psytz = false;
          }
        } else if(type == 'pre'){ //预包装
          if (this.fillFormDto.prePackagedGoodsFillList.length > 1) {//上一条有记录
            if (this.fillFormDto.prePackagedGoodsFillList[1].voucherUrl.animalVoucherList
              || this.fillFormDto.prePackagedGoodsFillList[1].voucherUrl.otherVoucherList
              || this.fillFormDto.prePackagedGoodsFillList[1].voucherUrl.tranVoucherList) {//有凭证图片
              this.plhc = this.fillFormDto.prePackagedGoodsFillList[1].voucherUrl;
              this.psytz = true;//可以使用上一条凭证按钮
            } else {
              this.psytz = false;
            }
          } else {
            this.psytz = false;
          }
        }
      }
    },
    qxPzUl(){//取消凭证
      this.pzUpShow = false;
      this.tranVoucherList = [];
      this.animalVoucherList = [];
      this.otherVoucherList = [];
      this.psytz = false;
      this.checkedValue = false;
      this.plhc = [];
    },
    tjPzUp(){//提交凭证
      if(this.tranVoucherList.length>0){//上传了交易凭证
        this.tranVoucherList[0].url = this.tranVoucherList[0].fileUrl;
        this.qzZcObj.tranVoucher = this.tranVoucherList[0].fileId;
      } else{
        this.qzZcObj.tranVoucher = '';
      }
      if(this.animalVoucherList.length>0){//上传了动检证
        this.animalVoucherList[0].url = this.animalVoucherList[0].fileUrl;
        this.qzZcObj.animalVoucher = this.animalVoucherList[0].fileId;
      } else{
        this.qzZcObj.animalVoucher = '';
      }
      if(this.otherVoucherList.length>0){//上传了其他凭证
        this.otherVoucherList[0].url = this.otherVoucherList[0].fileUrl;
        this.qzZcObj.otherVoucher = this.otherVoucherList[0].fileId;
      } else {
        this.qzZcObj.otherVoucher = '';
      }
      
      this.qzZcObj.voucherUrl.tranVoucherList = this.tranVoucherList;
      this.qzZcObj.voucherUrl.animalVoucherList = this.animalVoucherList;
      this.qzZcObj.voucherUrl.otherVoucherList = this.otherVoucherList;
      this.qxPzUl();
    },
    goodsChange(item,arr){  //回显单位
      let _id = item.goodCode;
      for(let i=0; i<arr.length;i++){
        if(arr[i].id == _id){
          item.buyQuantityUnit = arr[i].unit;
          item.priceUnit = '元/'+arr[i].unit;
          item.goodsFileUrl = arr[i].goodsFileUrl;
          return
        }
      }
    },
    submit(type) {//提交
      let fromdata = JSON.parse(JSON.stringify(this.fillFormDto))
      // if (this.type == 'add') {
        fromdata.disPrePackagedGoodsFillList.splice(0, 1);
        fromdata.prePackagedGoodsFillList.splice(0, 1);
      // }
      if (!fromdata.supplyId || !fromdata.buyPerson || !fromdata.buyDate) {
        this.$message.error('请完善基本信息');
        return
      }
      if((fromdata.disPrePackagedGoodsFillList.length + fromdata.prePackagedGoodsFillList.length)<1){
        this.$message.error('请添加商品信息');
        return
      }
      for(let i=0; i<fromdata.disPrePackagedGoodsFillList.length; i++){
        if(fromdata.disPrePackagedGoodsFillList[i].edit == 'edit'){
          this.$message.error('请确认正在编辑的非预包装食品填报');
          return
        }
      }
      for (let i = 0; i < fromdata.prePackagedGoodsFillList.length; i++) {
        if (fromdata.prePackagedGoodsFillList[i].edit == 'edit') {
          this.$message.error('请确认正在编辑的预包装食品填报');
          return
        }
      }
      // if(this.type =='add'){
        this.fillFormDto.disPrePackagedGoodsFillList.splice(0, 1);
        this.fillFormDto.prePackagedGoodsFillList.splice(0, 1);
      // }
      this.btn = true;
      api.goodsFillUpdate(this.fillFormDto).then(r=>{
        this.btn = false;
        if(r.code == 200){
          if(type == 'tj'){
            this.$message.success('提交成功');
            this.$router.go(-1);
          } else if(type == 'tjjx') {
            this.$message.success('提交成功');
            this.initData();
          }
        } else{
          this.$message.error(r.msg);
          this.addPrePackagedGoodsFillList();//添加预包装添加列表
          this.addDisPrePackagedGoodsFillList();//添加非预包装添加列表
        }
      })
    },
    initEditData() {
      api.goodsFillDetail({id: this.$route.query.id}).then(r=>{
        if(r.code == 200){
          this.fillFormDto = r.data;
          this.fillFormDto.prePackagedGoodsFillList.map(obj=>{
            this.$set(obj,'isGet','YES')
          })
          this.fillFormDto.disPrePackagedGoodsFillList.map(obj=>{
            this.$set(obj,'isGet','YES')
          })
          this.fillFormDto.delDisPrePackagedGoodsFillList = [];
          this.fillFormDto.delPrePackagedGoodsFillList = [];
          this.addPrePackagedGoodsFillList();//添加预包装添加列表
          this.addDisPrePackagedGoodsFillList();//添加非预包装添加列表
        }
      })
    }
  },
  mounted() {
    this.allList();//基本信息下拉列表
    this.id = this.$route.query.id ? this.$route.query.id : "";
  },
  created() {
    this.type = this.$route.query.type
    if(this.type === 'add') { // 新增页
      this.initData();
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      let date = now.getDate();
      this.fillFormDto.buyDate = year + '-' + (month < 10 ? ('0' + month) : month) + '-' + (date < 10 ? ('0' + date) : date);
    } else { // 编辑页
      this.initEditData()
    }
  }
};
</script>

<style scoped lang='scss'>
.pzPupopBox{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(51, 51, 51, 0.6);
  z-index: 901;
  .pzContentBox{
    position: absolute;
    width: 640px;
    height: 394px;
    background: #FFFFFF;
    border-radius: 4px;
    top: 160px;
    left: calc(50% - 320px);
    h3{
      height: 56px;
      line-height: 56px;
      background: #FFFFFF;
      border-radius: 4px 4px 0px 0px;
      padding: 0 20px;
      font-size: 16px;
      color: #333333;
      border-bottom: 1px solid #eee;
      margin-bottom: 30px;
      i{
        float: right;
        font-size: 20px;
        margin-top: 18px;
        cursor: pointer;
      }
    }
    .pzSpan{
      float: left;
      width: 150px;
      text-align: right;
    }
    .pzUploadBox{
      float: left;
      .ybUpload{
        width: 100px;
        height: 100px;
        overflow: hidden;
        margin-right: 30px;
      }
      .pzUploadDiv{
        display: flex;
        margin-bottom: 10px;
      }
      .tipP{
        color: #999999;
        font-size: 14px;
        margin-top: 10px;
      }
    }
    .imgNameP{
      margin-bottom: 20px;
      span{
        display: inline-block;
        width: 100px;
        margin-right: 30px;
        text-align: center;
        font-size: 14px;
        color: #666666;
      }
    }
    .psytz{
      margin-top: 245px;
      padding-left: 12px;
    }
    .btnDiv {
      margin-top: 20px;
      text-align: right;
      padding-right: 20px;
    }
    .mt265{
      margin-top: 265px;
    }
  }
  .h374{
    height: 374px;
  }
}
.addBox {
  width: calc(100% - 40px);
  min-height: calc(100% - 100px);
  padding: 0 20px 100px 20px;
  .title {
    height: 60px;
    line-height: 60px;
    .title_left {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 50%;
      height: 100%;
      .type {
        color: #70ce97;
      }
    }
  }
  .content{
    padding: 0 30px;
    .tabLab{
      width: 180px;
      display: block;
      text-align: center;
    }
  }
}
.margin-10{
  margin-left: -10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.w80{
  width: 80px;
}
.w140{
  width: 140px;
}
.pinzheng_span{
  font-size: 14px;
  color: #70CE97;
  cursor: pointer;
}
.w70{
  width: 70px;
}
</style>
<style>
  .goodsFillAdd_table th .cell:before{
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
  .goodsFillAdd_table thead tr th:nth-child(1) .cell:before,
  .goodsFillAdd_table thead tr th:nth-child(4) .cell:before,
  .goodsFillAdd_table thead tr th:nth-child(11) .cell:before,
  .goodsFillAdd_table thead tr th:nth-child(10) .cell:before,
  .tabLabDis thead tr th:nth-child(5) .cell:before,
  .tabLabDis thead tr th:nth-child(6) .cell:before{
    content: '';
  }
  .pzUploadBox .el-upload--picture-card{
    width: 100px;
    height: 100px;
    line-height: 120px;
  }
  .pzUploadBox .el-upload-list--picture-card .el-upload-list__item{
    width: 100px;
    height: 100px;
  }
</style>